const rootActionPath = 'core/BonusButton';

export const BONUS_BUTTON_MODAL_VIEWED = `${rootActionPath}/MODAL/VIEWED`;
export const BONUS_BUTTON_MODAL_CLOSED = `${rootActionPath}/MODAL/CLOSED`;

export const BONUS_BUTTON_POPUP_VIEWED = `${rootActionPath}/POPUP/VIEWED`;
export const BONUS_BUTTON_POPUP_EXPANDED = `${rootActionPath}/POPUP/EXPANDED`;
export const BONUS_BUTTON_POPUP_COLLAPSED = `${rootActionPath}/POPUP/COLLAPSED`;
